import { NumberFormatting } from 'Roblox';
import resellersModule from '../resellersModule.js';

function assetResaleDataPaneController(resellersConstants, languageResource) {
  'ngInject';

  const ctrl = this;

  ctrl.formatNumber = number => {
    if (number > 0) {
      return NumberFormatting.commas(number);
    }

    return languageResource.get(resellersConstants.translationKeys.notAvailable);
  };

  ctrl.setSelectedResaleChartDays = dayCount => {
    ctrl.selectedResaleChartDays = dayCount;
  };

  const init = () => {
    ctrl.chartDataAvailable =
      ctrl.resaleData.priceDataPoints.length > 0 && ctrl.resaleData.volumeDataPoints.length > 0;
    ctrl.historicalDataAvailable = ctrl.resaleData.recentAveragePrice > 0;
    ctrl.resaleChartDayOptions = resellersConstants.resaleChartDayOptions;
    ctrl.selectedResaleChartDays =
      resellersConstants.resaleChartDayOptions[resellersConstants.resaleChartDayOptions.length - 1];
  };

  ctrl.$onInit = init;
}

resellersModule.controller('assetResaleDataPaneController', assetResaleDataPaneController);
export default assetResaleDataPaneController;
